import script from "./CodecsisView.vue?vue&type=script&setup=true&lang=js"
export * from "./CodecsisView.vue?vue&type=script&setup=true&lang=js"

import "./CodecsisView.vue?vue&type=style&index=0&id=98272aea&lang=css"

const __exports__ = script;

export default __exports__